export const validateUserDoc = data => {
  const errors = [];

  if (!data.email || typeof data.email !== 'string' || !data.email.includes('@')) {
    errors.push('Valid email is required');
  }

  if (!data.firstname || typeof data.firstname !== 'string' || data.firstname.trim().length === 0) {
    errors.push('First name is required');
  }

  if (!data.lastname || typeof data.lastname !== 'string' || data.lastname.trim().length === 0) {
    errors.push('Last name is required');
  }

  if (!data.role || typeof data.role !== 'string') {
    errors.push('Role is required');
  }

  const validRoles = ['admin', 'moderator', 'alumni', 'client', 'coach'];
  if (data.role && !validRoles.includes(data.role)) {
    errors.push('Invalid role');
  }

  if (data.status && typeof data.status !== 'string') {
    errors.push('Status must be a string');
  }

  if (data.businessStage && typeof data.businessStage !== 'string') {
    errors.push('Business stage must be a string');
  }

  if (data.organization && typeof data.organization !== 'string') {
    errors.push('Organization must be a string');
  }

  if (data.cohortGroup && typeof data.cohortGroup !== 'string') {
    errors.push('Cohort group must be a string');
  }

  return {
    valid: errors.length === 0,
    errors,
  };
};

export const validateReportDoc = data => {
  const errors = [];

  if (!data.email || typeof data.email !== 'string' || !data.email.includes('@')) {
    errors.push('Valid email is required');
  }

  if (!data.title || typeof data.title !== 'string' || data.title.trim().length === 0) {
    errors.push('Title is required');
  }

  if (!data.content || typeof data.content !== 'string' || data.content.trim().length === 0) {
    errors.push('Content is required');
  }

  if (!data.status || typeof data.status !== 'string') {
    errors.push('Status is required');
  }

  const validStatuses = ['draft', 'submitted', 'approved', 'rejected'];
  if (data.status && !validStatuses.includes(data.status)) {
    errors.push('Invalid status');
  }

  if (data.attachments && !Array.isArray(data.attachments)) {
    errors.push('Attachments must be an array');
  }

  if (data.fileData && !Array.isArray(data.fileData)) {
    errors.push('File data must be an array');
  }

  if (data.uploadedBy && typeof data.uploadedBy !== 'object') {
    errors.push('Uploaded by must be an object');
  }

  return {
    valid: errors.length === 0,
    errors,
  };
};

export const validateDocumentBankDoc = data => {
  const errors = [];

  if (!data.category || typeof data.category !== 'string' || data.category.trim().length === 0) {
    errors.push('Category is required');
  }

  if (!data.fileName || typeof data.fileName !== 'string' || data.fileName.trim().length === 0) {
    errors.push('File name is required');
  }

  if (!data.fileSize || typeof data.fileSize !== 'number' || data.fileSize <= 0) {
    errors.push('Valid file size is required');
  }

  if (!data.fileType || typeof data.fileType !== 'string' || data.fileType.trim().length === 0) {
    errors.push('File type is required');
  }

  if (!data.scope || typeof data.scope !== 'string') {
    errors.push('Scope is required');
  }

  const validScopes = ['client', 'alumni', 'org', 'public'];
  if (data.scope && !validScopes.includes(data.scope)) {
    errors.push('Invalid scope');
  }

  if (!data.ownerId || typeof data.ownerId !== 'string' || data.ownerId.trim().length === 0) {
    errors.push('Owner ID is required');
  }

  if (!data.ownerEmail || typeof data.ownerEmail !== 'string' || !data.ownerEmail.includes('@')) {
    errors.push('Valid owner email is required');
  }

  if (!data.uploadedByRole || typeof data.uploadedByRole !== 'string') {
    errors.push('Uploaded by role is required');
  }

  if (
    !data.storagePath ||
    typeof data.storagePath !== 'string' ||
    data.storagePath.trim().length === 0
  ) {
    errors.push('Storage path is required');
  }

  if (!data.url || typeof data.url !== 'string' || data.url.trim().length === 0) {
    errors.push('Valid URL is required');
  }

  if (data.visibility && typeof data.visibility !== 'object') {
    errors.push('Visibility must be an object');
  }

  if (data.visibility) {
    if (!data.visibility.type || typeof data.visibility.type !== 'string') {
      errors.push('Visibility type is required');
    }

    const validVisibilityTypes = ['public', 'private', 'mixed'];
    if (data.visibility.type && !validVisibilityTypes.includes(data.visibility.type)) {
      errors.push('Invalid visibility type');
    }

    if (data.visibility.roles && !Array.isArray(data.visibility.roles)) {
      errors.push('Visibility roles must be an array');
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
};

export const validateEntrepreneurProfileDoc = data => {
  const errors = [];

  if (!data.userId || typeof data.userId !== 'string' || data.userId.trim().length === 0) {
    errors.push('User ID is required');
  }

  if (!data.userInfo || typeof data.userInfo !== 'object') {
    errors.push('User info is required');
  }

  if (data.userInfo) {
    if (
      !data.userInfo.email ||
      typeof data.userInfo.email !== 'string' ||
      !data.userInfo.email.includes('@')
    ) {
      errors.push('Valid user email is required');
    }

    if (
      !data.userInfo.firstname ||
      typeof data.userInfo.firstname !== 'string' ||
      data.userInfo.firstname.trim().length === 0
    ) {
      errors.push('User first name is required');
    }

    if (
      !data.userInfo.lastname ||
      typeof data.userInfo.lastname !== 'string' ||
      data.userInfo.lastname.trim().length === 0
    ) {
      errors.push('User last name is required');
    }
  }

  if (
    data.overallScore &&
    (typeof data.overallScore !== 'number' || data.overallScore < 0 || data.overallScore > 100)
  ) {
    errors.push('Overall score must be a number between 0 and 100');
  }

  if (data.notes && typeof data.notes !== 'string') {
    errors.push('Notes must be a string');
  }

  const validSections = [
    'businessModel',
    'businessStage',
    'industryContext',
    'marketPosition',
    'operationalMaturity',
    'scalabilityReadiness',
    'capabilities',
    'financialSkills',
    'leadershipSkills',
    'marketingSkills',
    'operationalSkills',
    'technicalSkills',
    'mindset',
    'motivation',
    'problemSolving',
    'selfEfficacy',
    'personality',
    'leadershipStyle',
    'personalityTraits',
    'riskTolerance',
  ];

  for (const section of validSections) {
    if (data[section] && typeof data[section] !== 'object') {
      errors.push(`${section} must be an object`);
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
};

export const validateAuditLogDoc = data => {
  const errors = [];

  if (!data.userId || typeof data.userId !== 'string' || data.userId.trim().length === 0) {
    errors.push('User ID is required');
  }

  if (!data.userEmail || typeof data.userEmail !== 'string' || !data.userEmail.includes('@')) {
    errors.push('Valid user email is required');
  }

  if (
    !data.collection ||
    typeof data.collection !== 'string' ||
    data.collection.trim().length === 0
  ) {
    errors.push('Collection is required');
  }

  if (!data.previousStage || typeof data.previousStage !== 'string') {
    errors.push('Previous stage is required');
  }

  if (!data.newStage || typeof data.newStage !== 'string') {
    errors.push('New stage is required');
  }

  if (!data.changedBy || typeof data.changedBy !== 'object') {
    errors.push('Changed by is required');
  }

  if (data.changedBy) {
    if (
      !data.changedBy.uid ||
      typeof data.changedBy.uid !== 'string' ||
      data.changedBy.uid.trim().length === 0
    ) {
      errors.push('Changed by UID is required');
    }

    if (
      !data.changedBy.email ||
      typeof data.changedBy.email !== 'string' ||
      !data.changedBy.email.includes('@')
    ) {
      errors.push('Valid changed by email is required');
    }
  }

  if (data.reason && typeof data.reason !== 'string') {
    errors.push('Reason must be a string');
  }

  return {
    valid: errors.length === 0,
    errors,
  };
};

export const validateMediaAuditLogDoc = data => {
  const errors = [];

  if (!data.userId || typeof data.userId !== 'string' || data.userId.trim().length === 0) {
    errors.push('User ID is required');
  }

  if (!data.kind || typeof data.kind !== 'string') {
    errors.push('Kind is required');
  }

  const validKinds = ['profile', 'banner'];
  if (data.kind && !validKinds.includes(data.kind)) {
    errors.push('Invalid kind');
  }

  if (!data.path || typeof data.path !== 'string' || data.path.trim().length === 0) {
    errors.push('Path is required');
  }

  if (!data.size || typeof data.size !== 'number' || data.size <= 0) {
    errors.push('Valid size is required');
  }

  if (!data.type || typeof data.type !== 'string' || data.type.trim().length === 0) {
    errors.push('Type is required');
  }

  if (!data.url || typeof data.url !== 'string' || data.url.trim().length === 0) {
    errors.push('Valid URL is required');
  }

  if (!data.uploadedBy || typeof data.uploadedBy !== 'object') {
    errors.push('Uploaded by is required');
  }

  if (data.uploadedBy) {
    if (
      !data.uploadedBy.uid ||
      typeof data.uploadedBy.uid !== 'string' ||
      data.uploadedBy.uid.trim().length === 0
    ) {
      errors.push('Uploaded by UID is required');
    }

    if (
      !data.uploadedBy.email ||
      typeof data.uploadedBy.email !== 'string' ||
      !data.uploadedBy.email.includes('@')
    ) {
      errors.push('Valid uploaded by email is required');
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
};

export const validateBusinessStage = stage => {
  const validStages = [
    'Idea',
    'Concept',
    'Prototype',
    'MVP',
    'Early Stage',
    'Growth',
    'Scale',
    'Commercialisation',
    'Mature',
    'Exit',
  ];

  return {
    valid: validStages.includes(stage),
    error: validStages.includes(stage) ? null : 'Invalid business stage',
  };
};

export const validateImageFile = file => {
  const errors = [];

  if (!file) {
    errors.push('No file provided');
    return { valid: false, errors };
  }

  const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
  if (!allowedTypes.includes(file.type)) {
    errors.push('Invalid file type. Only JPEG, PNG, and WebP are allowed');
  }

  const maxSize = 5 * 1024 * 1024; // 5MB
  if (file.size > maxSize) {
    errors.push('File size too large. Maximum size is 5MB');
  }

  if (file.size === 0) {
    errors.push('File is empty');
  }

  return {
    valid: errors.length === 0,
    errors,
  };
};

export const validateEmail = email => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return {
    valid: emailRegex.test(email),
    error: emailRegex.test(email) ? null : 'Invalid email format',
  };
};

export const validateUrl = url => {
  try {
    new URL(url);
    return { valid: true, error: null };
  } catch {
    return { valid: false, error: 'Invalid URL format' };
  }
};

export const validatePhoneNumber = phone => {
  const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
  return {
    valid: phoneRegex.test(phone),
    error: phoneRegex.test(phone) ? null : 'Invalid phone number format',
  };
};

export const validateString = (value, fieldName, minLength = 1, maxLength = 1000) => {
  if (typeof value !== 'string') {
    return { valid: false, error: `${fieldName} must be a string` };
  }

  if (value.trim().length < minLength) {
    return { valid: false, error: `${fieldName} must be at least ${minLength} characters long` };
  }

  if (value.trim().length > maxLength) {
    return {
      valid: false,
      error: `${fieldName} must be no more than ${maxLength} characters long`,
    };
  }

  return { valid: true, error: null };
};

export const validateNumber = (value, fieldName, min = 0, max = Number.MAX_SAFE_INTEGER) => {
  if (typeof value !== 'number' || isNaN(value)) {
    return { valid: false, error: `${fieldName} must be a number` };
  }

  if (value < min) {
    return { valid: false, error: `${fieldName} must be at least ${min}` };
  }

  if (value > max) {
    return { valid: false, error: `${fieldName} must be no more than ${max}` };
  }

  return { valid: true, error: null };
};
